import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const styleMap = {
  primary:
    "inline-flex items-center justify-center gap-2 rounded-xl bg-midnight-navy px-6 py-3 text-sm font-semibold text-soft-white shadow-soft hover:bg-royal-blue",
  secondary:
    "inline-flex items-center justify-center gap-2 rounded-xl border border-midnight-navy/20 bg-white/80 px-6 py-3 text-sm font-semibold text-midnight-navy hover:border-royal-blue/40 hover:bg-royal-blue/5",
  ctaPrimary:
    "inline-flex items-center justify-center gap-2 rounded-xl bg-soft-white px-6 py-3 text-sm font-semibold text-midnight-navy hover:bg-sky-glow",
  ctaSecondary:
    "inline-flex items-center justify-center gap-2 rounded-xl border border-white/35 bg-white/10 px-6 py-3 text-sm font-semibold text-soft-white hover:bg-white/20"
};

function CountryActionLink({ to, label, variant = "secondary", className = "" }) {
  const baseClass = styleMap[variant] || styleMap.secondary;
  const showArrow = variant === "primary" || variant === "ctaPrimary";

  if (to?.startsWith("/")) {
    return (
      <Link to={to} className={`${baseClass} ${className}`} data-flight-message={label}>
        {label}
        {showArrow ? <ArrowRight className="h-4 w-4" aria-hidden="true" /> : null}
      </Link>
    );
  }

  return (
    <a href={to} className={`${baseClass} ${className}`} data-flight-message={label}>
      {label}
      {showArrow ? <ArrowRight className="h-4 w-4" aria-hidden="true" /> : null}
    </a>
  );
}

export default CountryActionLink;
